"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _GetForegroundColorForColor = require("../../helpers/GetForegroundColorForColor/GetForegroundColorForColor");
var _propTypes = require("prop-types");
var _templateObject, _templateObject2, _templateObject3;
var StyledLabel = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 2px;\n  font-size: 14px;\n  text-align: center;\n  max-width: 110px;\n  height: 28px;\n  margin: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 8px;\n  padding-bottom: 1px;\n"])));
var TextNode = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (props) {
  return props.width;
});
var IconWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0 4px 0 4px;\n  cursor: 'pointer';\n"])));
var Label = exports.Label = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var color = _ref.color,
    text = _ref.text,
    onClick = _ref.onClick;
  var textNodeWidth = onClick ? '94px' : '110px';
  var IconNode = onClick ? /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    onClick: onClick,
    "aria-label": "Remove the label ".concat(text)
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimes
  })) : null;
  var foregroundColor = (0, _GetForegroundColorForColor.getForegroundColorPerBackgroundContrast)(color);
  var inlineStyle = {
    background: color,
    color: foregroundColor
  };
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    style: inlineStyle
  }, /*#__PURE__*/_react["default"].createElement(TextNode, {
    width: textNodeWidth
  }, text), IconNode);
});
Label.propTypes = {
  text: _propTypes.PropTypes.string.isRequired,
  color: _propTypes.PropTypes.string.isRequired,
  onClick: _propTypes.PropTypes.func
};